import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";

import Routes from "./routes";
import theme from "theme";
import ButtonInvite from "components/ButtonInvite";

export default function App() {
  if (localStorage.getItem("language")) {
  } else {
    localStorage.setItem("language", "pt");
  }

  return (
    <ChakraProvider theme={theme}>
      <ButtonInvite />
      <Routes />
    </ChakraProvider>
  );
}
